"use client";

import {
// LoaderIcon,
MicIcon, PlusIcon
// SendHorizontalIcon,
} from "lucide-react";
import { useCallback, useEffect, useRef } from "react";
import { toast } from "sonner";
import { useLocalStorage } from "usehooks-ts";
export default function ChatInput({
  status,
  handleSubmit,
  input,
  setInput,
  chatId
}) {
  const textareaRef = useRef(null);
  const [localStorageInput, setLocalStorageInput] = useLocalStorage("input", "");
  useEffect(() => {
    if (textareaRef.current) {
      const domValue = textareaRef.current.value;
      const finalValue = domValue || localStorageInput || "";
      setInput(finalValue);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    setLocalStorageInput(input);
  }, [input, setLocalStorageInput]);
  const submitForm = useCallback(() => {
    window.history.replaceState({}, "", `/app/${chatId}`);
    handleSubmit(undefined, {
      experimental_attachments: []
    });
    setLocalStorageInput("");
  }, [handleSubmit, setLocalStorageInput, chatId]);
  return <div className="max-w-xl ring-4 ring-[#6969691A] shadow-xl relative gap-2 bg-white  w-full rounded-2xl flex flex-col">
      <div className="bg-[linear-gradient(180deg,rgba(0,0,0,0.22)_50%,rgba(0,0,0,0.44)_100%)] p-[1px] rounded-2xl">
        <div className="flex flex-col gap-1 w-full rounded-2xl bg-white ">
          <textarea autoFocus className="size-full placeholder:text-foreground/60 outline-none pt-4 field-sizing-content resize-none text-base px-4 max-h-40 overflow-y-auto" placeholder="Ask anything..." ref={textareaRef} value={input} onChange={e => setInput(e.target.value)} onKeyDown={event => {
          if (event.key === "Enter" && !event.shiftKey && !event.nativeEvent.isComposing) {
            event.preventDefault();
            if (status !== "ready") {
              toast.error("Please wait for the model to finish its response!");
            } else {
              submitForm();
            }
          }
        }}></textarea>
          <div className="p-2 w-full flex">
            <button type="button" className="size-10 flex justify-center items-center cursor-pointer hover:bg-foreground/5 rounded-xl">
              <PlusIcon className="size-6" />
            </button>
            <button type="button" className="size-10 flex justify-center items-center cursor-pointer hover:bg-foreground/5 rounded-xl">
              <MicIcon className="size-5.5" />
            </button>
          </div>
        </div>
      </div>
      {/* <button
        onClick={submitForm}
        type="button"
        disabled={status !== "ready"}
        className="cursor-pointer disabled:opacity-50 disabled:pointer-events-none absolute right-4 bottom-2.5 shrink-0 bg-neutral-800 hover:bg-neutral-800/90 transition-colors rounded-full size-8 text-white flex justify-center items-center"
       >
        {status === "ready" ? (
          <SendHorizontalIcon className="size-4" />
        ) : (
          <LoaderIcon className="size-4 animate-spin" />
        )}
       </button> */}
    </div>;
}